export default "__VITE_ASSET__tXRC4UH9__"